<i18n>
zh-TW:
  down: 下載應用程式

zh-TW2:
  down: 下載應用程式

zh-MO:
  down: 下載應用程式

en:
  down: DOWNLOAD

ja:
  down: ダウンロード

ko:
  down: APP 다운
</i18n>

<script>
import appInstall from '@/utils/app-install'
export default {
  props: {
    router: {
      type: String,
      // 命中 appInstall 入参默认值
      default: undefined
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      closeCover:
        'https://cdn.poizon.com/node-common/MDglMjAlRTUlOUIlQkUlRTYlQTAlODdfY2xvc2VAM3gxNTg3MDQyMDQ2MjU0.png',
      logo:
        'https://cdn.poizon.com/node-common/cG9pem9uXzEwOF8xMDhAM3gxNTg3MDQyMDYwNDE4.png',
      isShow: true
    }
  },
  methods: {
    close() {
      this.isShow = false
    },
    download() {
      const { router, params } = this
      appInstall(router, params)
    }
  },
  render() {
    if (this.isShow) {
      return (
        <div class="download-bar">
          <img
            class="close"
            onClick={this.close}
            src={this.closeCover}
            alt="x"
          />
          <img class="logo" src={this.logo} alt="poizon" />
          <div class="cont">
            <div class="tit">POIZON</div>
            <div class="desc">Stay Real to Fashion</div>
          </div>
          <button class="down" onClick={this.download}>
            {this.$t('down')}
          </button>
        </div>
      )
    }
    return ''
  }
}
</script>
<style lang="scss" scoped>
.download-bar {
  padding: 24px 40px 24px 48px;
  display: flex;
  align-items: center;
  background-color: #f5f5f9;
}

.close {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
}

.logo {
  width: 96px;
  height: 96px;
  margin: 0 24px;
  flex: 0 0 96px;
}

.cont {
  height: 96px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.tit {
  color: rgba(0, 0, 0, 0.9);
  font-size: 28px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
}

.desc {
  color: rgba(0, 0, 0, 0.9);
  font-size: 24px;
  font-family: PingFangSC-Regular;
  font-weight: normal;
}

.down {
  display: block;
  flex-flow: 0;
  padding: 21px 40px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 24px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  background-color: rgb(1, 194, 195);
  border-radius: 1px;
  border: none;
}
</style>
